import React, { useEffect, useRef, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Role from './Role';
import RoleService from '../../../services/RoleService/RoleService';
import { ADMIN, GUEST, AUTOM_MAKER, IPAAS_DEV, RPA_DEV } from '../../../services/config';
import UpdateRole from './UpdateRole';
import Search from '../../../components/Search/Search';
import DeleteConfirm from '../../../components/DataTable/DeleteConfirm';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../recoil-store/recoil-state';
import './RoleEditor.css';

/**
 * @Description This function lets you return Role editor page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function RoleEditor() {
    const { t } = useTranslation();
    const roles = useRef([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [dialog, setDialog] = useState();
    const [selectedRoles, setSelectedRoles] = useState([]);
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        fetchData().then(r => r);
    }, []);

    const fetchData = async () => {
        let response = await RoleService.getRoles();
        if (response?.data?.status) {
            let data = response.data.data;
            let filteredData = data.filter((a) => (
                a.id !== ADMIN.ROLE_ID && a.id !== GUEST.ROLE_ID && a.id !== AUTOM_MAKER.ROLE_ID &&
                a.id !== IPAAS_DEV.ROLE_ID && a.id !== RPA_DEV.ROLE_ID
            ));
            roles.current = filteredData;
            setSearchData(filteredData);
        }
    }

    const handleDeleteRole = async () => {
        if (selectedRoles.length > 0) {
            const res = await RoleService.deleteRole(selectedRoles);
            if (res.status) {
                setSelectedRoles([]);
                await fetchData();
            }
        }
    }

    const handleDeleteClick = () => {
        if (selectedRoles.length > 0) {
            setOpenDelete(true);
        }
    }

    const handleAddNewRole = () => {
        setDialog({ type: 'add' });
    };

    const showAlert = (message, status = false) => {
        setAlert(alert => ({ ...alert, show: true, message: message, severity: status ? 'success' : 'error' }));
    }
    const btnStyle = {
        backgroundColor: '#fff',
        color: '#8f94a6',
        fontWeight: 700,
        boxShadow: '0px 0px 8px #00000040',
        marginLeft: 20,
        marginTop: 5,
        fontSize: 11
    };
    return (
        <div style={{ width: '100%' }}>
            <Search data={roles.current} setSearchData={setSearchData} searchKey={['role_name', 'role_description']} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}>
                <div>
                    <Button style={btnStyle} onClick={handleAddNewRole}>{t('CONTENT.ROLE.ADD-NEW-ROLE')}</Button>
                    <Button style={btnStyle} onClick={handleDeleteClick}>{t('CONTENT.ROLE.DELETE-ROLE')}</Button>
                </div>
            </Search>
            <TableContainer>
                <Table>
                    <TableBody>
                        {searchData.map((row, rowI) => (
                            <Role key={rowI} role={row} selectedRoles={selectedRoles} setSelectedRoles={setSelectedRoles} showAlert={showAlert}
                                fetchRoles={fetchData} setDialog={setDialog} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {dialog && <UpdateRole dialog={dialog} setDialog={setDialog} roles={roles.current} fetchData={fetchData} />}
            {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete}
                message={`${selectedRoles.length} ${t('CONTENT.ROLE.DELETE-WARNING')}`}
                deleteFunc={handleDeleteRole} />}
        </div>
    );
}

export default RoleEditor;
